import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function CoachStatsManager() {
  const [stats, setStats] = useState({ since_year: 2021, members_count: 120, sessions_per_year: 1800 });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/coach-stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/coach-stats", {
        since_year: Number(stats.since_year),
        members_count: Number(stats.members_count),
        sessions_per_year: Number(stats.sessions_per_year),
      });
      setStats(data);
      toast.success("Chiffres mis à jour sur la landing");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const years = Math.max(0, new Date().getFullYear() - Number(stats.since_year));

  return (
    <div className="rounded-2xl border border-stone-200 bg-white p-8">
      <div className="mb-6">
        <h2 className="font-display text-2xl font-light text-stone-900">Chiffres clés du coach</h2>
        <p className="mt-1 text-sm text-stone-500">Ces valeurs s'affichent sous la bio de la landing. Modifiez-les à tout moment.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <div>
          <Label htmlFor="cs-since" className="text-xs uppercase tracking-[0.2em] text-stone-500">Certifié depuis (année)</Label>
          <Input
            id="cs-since"
            data-testid="stats-since"
            type="number"
            min="1980"
            max="2100"
            value={stats.since_year}
            onChange={(e) => setStats({ ...stats, since_year: e.target.value })}
            className="mt-2 h-11 bg-white text-stone-900 placeholder:text-stone-400"
          />
          <p className="mt-1 text-xs text-stone-500">→ « {years}+ années d'expérience »</p>
        </div>
        <div>
          <Label htmlFor="cs-members" className="text-xs uppercase tracking-[0.2em] text-stone-500">Clients accompagnés</Label>
          <Input
            id="cs-members"
            data-testid="stats-members"
            type="number"
            min="0"
            value={stats.members_count}
            onChange={(e) => setStats({ ...stats, members_count: e.target.value })}
            className="mt-2 h-11 bg-white text-stone-900 placeholder:text-stone-400"
          />
        </div>
        <div>
          <Label htmlFor="cs-sessions" className="text-xs uppercase tracking-[0.2em] text-stone-500">Séances par an</Label>
          <Input
            id="cs-sessions"
            data-testid="stats-sessions"
            type="number"
            min="0"
            value={stats.sessions_per_year}
            onChange={(e) => setStats({ ...stats, sessions_per_year: e.target.value })}
            className="mt-2 h-11 bg-white text-stone-900 placeholder:text-stone-400"
          />
        </div>
      </div>
      <Button
        data-testid="stats-save"
        onClick={save}
        disabled={saving}
        className="mt-6 rounded-full bg-stone-900 px-6 hover:bg-stone-800"
      >
        {saving ? "Enregistrement…" : "Mettre à jour les chiffres"}
      </Button>
    </div>
  );
}
